import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CmsApiService } from 'src/app/services/api/cms.api.service';

@Component({
  selector: 'app-video-tutorials',
  templateUrl: './video-tutorials.component.html',
  styleUrls: ['./video-tutorials.component.scss'],
})
export class VideoTutorialsComponent implements OnInit {
  @ViewChild('videoTutorial') videoTutorial: ElementRef;

  private iframeSrc = '';
  private called = false;

  constructor(private cmsApi: CmsApiService) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.cmsApi.mystatusChanged.subscribe(() => {
      this.updatedStatus();
      this.called = true;
    });
    if (!this.called) {
      this.updatedStatus();
    }
  }

  updatedStatus() {
    this.iframeSrc = this.cmsApi.getVideoTutorialCMSUrl();
    this.videoTutorial.nativeElement.setAttribute('src', this.iframeSrc);
  }
}
